const FALLBACK_TIME_ZONES = [
  'UTC',
  'America/New_York',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Asia/Jerusalem',
  'Asia/Dubai',
  'Asia/Hong_Kong',
];

export function getTimeZoneOptions() {
  if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
    try {
      return Intl.supportedValuesOf('timeZone');
    } catch {
      return FALLBACK_TIME_ZONES;
    }
  }
  return FALLBACK_TIME_ZONES;
}
